import { coreApp } from "../../App/CoreApp"
import { CoreBaseApi, CoreBaseApiResult } from "../CoreBaseApi";
import { CoreBaseApiEndpoint } from "../CoreBaseApiEndpoint";

export class CoreBaseApiAuthEndpoint extends CoreBaseApiEndpoint {
    private _authToken: string;
    private lsKey = '_core_auth';
    public getAuthToken () {
        return this._authToken;
    }
    
    public isLoggedIn() {
        return typeof this._authToken !== 'undefined' && this._authToken !== null;
    }
    
    // public login(username: string, pass: string): Promise<CoreBaseApiResult<boolean>> {
    //     return this.getMockResult(true).then((result: any) => {
    //         this._authToken = 'token';
    //         localStorage.setItem(this.lsKey, this._authToken);
    //         return result;
    //     });
    // }

    // public register(firstName: string, lastName: string, username: string, password: string, confirmPassword: string): Promise<CoreBaseApiResult<boolean>> {
    //     return this.getMockResult(true).then((result: any) => {
    //         return result;
    //     });
    // }

    // public forgotPassword(username: string): Promise<CoreBaseApiResult<boolean>> {
    //     return this.getMockResult(true).then((result: any) => {
    //         return result;
    //     });
    // }

    constructor(api: CoreBaseApi) {
        super(api)
        this._authToken = localStorage.getItem(this.lsKey);
    }
}